// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ApplicationWithRelationsSchema } from './ApplicationRelationsSchema'
import type { ApplicationWithRelations } from './ApplicationRelationsSchema'
import { BusinessUnitWithRelationsSchema } from './BusinessUnitRelationsSchema'
import type { BusinessUnitWithRelations } from './BusinessUnitRelationsSchema'
import { ApplicationBusinessUnitSchema } from './ApplicationBusinessUnitSchema';

/////////////////////////////////////////
// APPLICATION BUSINESS UNIT RELATION SCHEMA
/////////////////////////////////////////

export type ApplicationBusinessUnitRelations = {
  application: ApplicationWithRelations;
  businessUnit: BusinessUnitWithRelations;
};

export type ApplicationBusinessUnitWithRelations = z.infer<typeof ApplicationBusinessUnitSchema> & ApplicationBusinessUnitRelations

export const ApplicationBusinessUnitWithRelationsSchema: z.ZodType<ApplicationBusinessUnitWithRelations> = ApplicationBusinessUnitSchema.merge(z.object({
  application: z.lazy(() => ApplicationWithRelationsSchema),
  businessUnit: z.lazy(() => BusinessUnitWithRelationsSchema),
}))